// Legacy /me/item/:itemId/logbook landing. An item can now have several
// logbooks, so this bare path no longer maps to a single list. Status emails
// and old bookmarks still link here, so resolve to something sensible:
//   - one or more logbooks -> the first (name-sorted) logbook's list
//   - no logbooks          -> the item page (where the user can add one)

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useStatusMessage } from '../../components';
import * as Database from '../../utilities/Database.mjs';
import { urlForLogbookForId, urlForItem } from '../../fleet-shared/Urls.mjs';

export const LogbookRedirect = () => {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const [StatusMessage, { showLoading, showError }] = useStatusMessage();

  useEffect(() => {
    let mounted = true;
    async function resolve() {
      try {
        showLoading();
        const logbooks = await Database.listLogbooks(itemId);
        if (!mounted) return;
        if (logbooks.length > 0) {
          navigate(urlForLogbookForId(itemId, logbooks[0].id), { replace: true });
        } else {
          navigate(urlForItem(itemId), { replace: true });
        }
      } catch (err) {
        if (mounted) showError(err);
      }
    }
    resolve();
    return () => { mounted = false; };
  }, [itemId, navigate, showLoading, showError]);

  return <StatusMessage />;
};

export default LogbookRedirect;
